
























































import Enumerable from "linq";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { Directory } from "../../../domain/drawing";
import { FormatReference, WriteMethodTypeValue } from "../../../domain/format";
import { BinaryFinder } from "../../../utilities";
import { FilterableMasterSelectableMixin, MultiOrderableSelectableMixin } from "../../system/selectors/mixins";
import MultiOrderableCustomListBoxSelector from "../../system/selectors/MultiOrderableCustomListBoxSelector.vue";
import CustomListBoxSelector from "../../system/selectors/CustomListBoxSelector.vue";
import FormatsSelector from "./FormatsSelector.vue";

@Component({
  components: {
    FormatsSelector,
    CustomListBoxSelector,
    MultiOrderableCustomListBoxSelector,
  },
})
export default class MultiOrderableFormatListSelector extends Mixins(FilterableMasterSelectableMixin, MultiOrderableSelectableMixin) {
  static readonly Tabs: {[key: string]: any} = FormatsSelector.Tabs;
  static readonly formatTabs: any[] = FormatsSelector.formatTabs;
  static readonly formatSetTabs: any[] = FormatsSelector.formatSetTabs;
  static readonly allTabs: any[] = FormatsSelector.allTabs;

  @Prop()
  visibleTabs: any[];

  @Prop({ default: false })
  containsExpired: boolean;

  @Prop({ default: false })
  containsDeleted: boolean;

  @Prop({ default: false })
  shouldIgnoreChained: boolean;

  @Prop({ default: null })
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  @Prop()
  selectionMaxCount: number;

  @Prop({ default: false })
  isVisible: boolean;

  @Prop({ default: false })
  defaultMultiSelect: boolean;

  @Prop({ default: false })
  shouldIncludeReferenceableGroupFormats: boolean;

  @Emit()
  formatsSelected(selectedFormats: FormatReference[]): void {}

  values: FormatReference[];

  data(): any {
    return {
      selectingFormats: [],
      hashTableDirectoryPathForEachFormat: {},
      isMultiSelectChecked: true,
      isMultiSelectMode: true,
      isInitializing: false,
    };
  }
  selectingFormats: FormatReference[];
  hashTableDirectoryPathForEachFormat: { [key: number]: string };
  // 複数選択チェックボックスのチェック状態
  isMultiSelectChecked: boolean;

  // 複数選択モードかどうか(複数/単数切り替え中止時のちらつき防止のためisMultiSelectCheckedと分けている。)
  // (項目を複数選択した状態で複数選択チェックを外すと確認メッセージを表示してチェック外すのを中止できる。)
  isMultiSelectMode: boolean;
  isInitializing: boolean;

  get valueOptions(): FormatReference[] {
    return !!this.values
      ? this.values.slice() // 複製して処理する
      : [];
  }

  get appliedFilter(): (source: FormatReference) => boolean {
    // ツリーで選択されてる物のみに表示を絞り込む.
    return this.createFilter(this.selectingFormats);
  }

  get isSelectionCountVisible(): boolean {
    return this.shouldShowSelectionCount && this.isMultiSelectMode;
  }

  get singleEditingSource(): FormatReference {
    return (this.editingSource && this.editingSource.length === 1)
      ? this.editingSource[0]
      : null;
  }

  set singleEditingSource(source: FormatReference) {
    this.editingSource = source
      ? [source]
      : null;
  }

  createFilter(formats: FormatReference[]): (source: FormatReference) => boolean {
    const finder = new BinaryFinder((f: FormatReference) => f.id);
    const sortedFormats = finder.sort(formats);
    return s => !!finder.find(s, sortedFormats);
  }

  created() {
    this.loadFormats();
  }

  @Watch("shouldIncludeReferenceableGroupFormats")
  onShouldIncludeReferenceableGroupFormatsUpdated(): void {
    // よほどのことが無い限りはここは通らない見込みだが念のため対応している
    this.values = null;
    this.loadFormats();
  }

  private async loadFormats(): Promise<void> {
    try {
      // valuesには選択されうる全選択肢を設定する事.(右側にはvaluesに入ってる物しか表示されないので.)
      const repository = DomainRegistry.format.getFormatRepository();
      const formats = await repository.getFormats(this.shouldIgnoreChained, this.shouldIncludeReferenceableGroupFormats);
      this.values = this.toArray(formats);
    } catch (e) {
      this.$error(this.$wording.format.name + "情報取得失敗", this.$wording.format.name + "情報を取得できませんでした。", e);
    }
  }

  mounted() {
    this.initialize();
  }

  private initialize(): void {
    this.isInitializing = true;
    this.isMultiSelectChecked = this.defaultMultiSelect;
    this.onIsMultiSelectCheckedChanged(this.defaultMultiSelect);
    this.isInitializing = false;
  }

  toArray(source: Directory<string, FormatReference>[]): FormatReference[] {
    return Enumerable.from(source)
      .select(s => this.directoryToArray(s))
      .aggregate([], (s, f) => s.concat(f));
  }

  directoryToArray(source: Directory<string, FormatReference>): FormatReference[] {
    return Enumerable.from(source.entities)
      .concat(this.toArray(source.nodes))
      .toArray();
  }

  toLabelClass(row: FormatReference): string {
    return row.expired || row.deleted
      ? "invalid"
      : "";
  }

  toLabel(row: FormatReference): string {
    return row.name;
  }

  toDirector(row: FormatReference): string {
    return this.hashTableDirectoryPathForEachFormat[row.id]
      ? this.hashTableDirectoryPathForEachFormat[row.id]
      : "";
  }

  hashTableDirectoryPathForEachFormatUpdated(value: { [key: number]: string }): void {
    this.hashTableDirectoryPathForEachFormat = value;
  }

  doubleClick(source: FormatReference): void {
    this.formatsSelected([source]);
  }

  @Watch("isVisible")
  onIsVisibleChanged(newValue: boolean) {
    if (newValue) {
      this.initialize();
    }
  }

  @Watch("isMultiSelectChecked")
  async onIsMultiSelectCheckedChanged(newValue: boolean): Promise<void> {
    if (!newValue && this.editingSource && this.editingSource.length > 1) {
      if (this.isInitializing) {
        this.isMultiSelectChecked = true;
        return;
      }
      const index = await this.$commonDialogs.confirmation.confirmDestructCancel(
        "確認",
        ["選択中の内容を破棄しますが、よろしいですか？"]
      );
      if (index === 0) {
        this.editingSource = [];
        this.isMultiSelectMode = false;
      } else {
        this.isMultiSelectChecked = true;
      }
      return;
    }
    this.isMultiSelectMode = newValue;
  }
}
